import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { IAmiHead } from 'src/app/@amiga-pyme/components/ami-head/ami-head.interface';
import { SunatReportService } from '../sunat-report.service';
import { ISunatHistoryItem, SUNAT_REPORT_TTL, ISunatPreviewRow } from '../sunat-report.interface';
import { getDateTimeForFileName } from 'src/helpers/date-helper';

@Component({
  selector: 'app-sunat-report',
  templateUrl: './sunat-report.component.html',
  styleUrls: ['./sunat-report.component.scss']
})
export class SunatReportComponent extends TableActionsTemplate implements OnInit, OnDestroy {

  settingsAmiHead: IAmiHead = {
    title: SUNAT_REPORT_TTL,
    addressImg: 'reports'
  };

  displayDetailModal = false;
  previewData: ISunatPreviewRow[] = [];
  selectedHistoryItem: ISunatHistoryItem | null = null;

  constructor(
    private serviceBase: SunatReportService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(SUNAT_REPORT_TTL, serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Historial de Exportaciones',
      filterColumns: true,
      columns: [
        { header: 'Fecha', field: 'date' },
        { header: 'Período', field: 'period' },
        { header: 'Formato', field: 'format', tag: 'tagFormat' },
        { header: 'Usuario', field: 'user' },
        { header: 'Negocio', field: 'business' }
      ]
    };

    this.table.actions = [
      {
        icon: 'pi pi-eye',
        pTooltip: 'Ver Detalle',
        name: 'viewDetails',
        class: 'p-button-rounded p-button-text p-button-info mr-2',
        visible: () => true
      },
      {
        icon: 'pi pi-download',
        pTooltip: 'Descargar TXT',
        name: 'downloadMsj',
        class: 'p-button-rounded p-button-text p-button-secondary mr-2',
        visible: (rowData: any) => !!rowData.isTxt // true solo si isTxt es true
      },
      {
        icon: 'pi pi-file-excel',
        pTooltip: 'Descargar Excel',
        name: 'downloadExcel',
        class: 'p-button-rounded p-button-text p-button-success',
        visible: (rowData: any) => !!rowData.isXlsx // true solo si isXlsx es true
      }
    ];

    this.initSubscriptions$();
  }



  initSubscriptions$() {
    this.loadPage(1, 10);
  }
  loadingTable = false;


  loadPage(page: number, limit: number) {
    this.loadingTable = true;
    this.serviceBase
      .getExportHistory(2, { page, limit })
      .subscribe((response: any) => {

        const items = response.body?.data?.items || [];
        const meta = response.body?.data?.meta;

        this.table.data = items.map((item: any) => ({
          date: new Date(item.exportDate).toLocaleString('es-PE', {
            timeZone: 'America/Lima',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          }),
          period: `${item.periodMonth}/${item.periodYear}`,
          format: item.isTxt && item.isXlsx
            ? 'TXT + EXCEL'
            : item.isTxt
              ? 'TXT'
              : item.isXlsx
                ? 'EXCEL'
                : 'Ningún formato seleccionado',
          user: `${item.user.names} ${item.user.surnames}`,
          tagFormat: item.isTxt ? 'success' : 'warning',
          business: item.business.name,
          businessId: item.business.id,
          isTxt: !!item.isTxt,
          isXlsx: !!item.isXlsx
        }));

        // 🔥 ESTO ES CLAVE PARA SERVER SIDE
        this.table.settings.totalRecords = meta?.totalItems ?? items.length;
        this.table.settings.serverSide = true;
        this.loadingTable = false;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }

  // Action handler from table
  override onReciveAction(event: any) {
    switch (event.action) {
      case 'viewDetails':
        this.openDetails(event.data);
        break;
      case 'create':
        this.showWizard();
        break;
      case 'downloadMsj':
        this.downloadTxt(event.data);
        break;
      case 'downloadExcel':
        this.downloadExcel(event.data);
        break;
      case 'paginate':
        this.loadPage(event.data.page, event.data.limit);
        break;
    }
  }




  openDetails(item: any) {
    this.selectedHistoryItem = item;
    this.displayDetailModal = true;
  }

  loadingDownload = false;
  loadingMessage = '';




  downloadTxt(item: any) {
    this.loadingDownload = true;
    this.loadingMessage = 'Descargando TXT...';

    const businessId = Number(item.businessId);
    const [month, year] = String(item.period).split('/');
    const periodo = `${year}${month.padStart(2, '0')}00`;

    this.serviceBase.downloadKardexTxt(businessId, periodo).subscribe({
      next: (response) => {
        const blob = response.body;

        if (!blob) {
          console.error("No se recibió el archivo TXT (blob vacío)");
          this.loadingDownload = false;
          return;
        }


        const fileName = `KDX_${item.business}_${periodo}_${getDateTimeForFileName()}.txt`;

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);

        this.loadingDownload = false;
      },
      error: (err) => {
        console.error('Error descargando TXT:', err);
        this.loadingDownload = false;
      }
    });
  }

  downloadExcel(item: any) {
    this.loadingDownload = true;
    this.loadingMessage = 'Descargando Excel...';

    const businessId = Number(item.businessId);
    const [month, year] = String(item.period).split('/');
    const periodo = `${year}${month.padStart(2, '0')}00`;

    this.serviceBase.downloadKardexExcel(businessId, periodo).subscribe({
      next: (response) => {
        const blob = response.body;

        if (!blob) {
          console.error("No se recibió el archivo (blob vacío)");
          this.loadingDownload = false;
          return;
        }

        const fileName = `KDX_${item.business}_${periodo}_${getDateTimeForFileName()}.xlsx`;

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);

        this.loadingDownload = false;
      },
      error: (err) => {
        console.error('Error descargando Excel:', err);
        this.loadingDownload = false;
      }
    });
  }


  showWizard() {
    console.log('showWizard ....... ');
    this.router.navigate(['new-exportation'], { relativeTo: this.route });
  }
}
